import {
  LayoutDashboard, Globe, HelpCircle, Star, Briefcase, Settings as SettingsIcon,
  Eye, Pencil, EyeOff, Share2, ImageIcon, Info, EyeIcon, MousePointer2,
  Users, Menu, Mail, FileText, Type, List, FormInput, Phone, Layout,
  Inbox, Shield, Tag, MessageSquare, Search, ChevronLeft, Languages,
  FolderTree, BookOpen
} from "lucide-react";

export const MODES = ["off", "readonly", "edit"];
export const MODE_CONFIG = {
  off: { label: "Oculto", Icon: EyeOff, color: "text-red-500", bg: "bg-red-50", border: "border-red-200" },
  readonly: { label: "Leitura", Icon: Eye, color: "text-amber-500", bg: "bg-amber-50", border: "border-amber-200" },
  edit: { label: "Edição", Icon: Pencil, color: "text-green-500", bg: "bg-green-50", border: "border-green-200" },
};

export const ADMIN_TABS = [
  { uid: "leads", label: "Leads", Icon: Inbox },
  { uid: "site", label: "Site", Icon: Layout },
  { uid: "email", label: "Email", Icon: Mail },
  { uid: "faq", label: "FAQ", Icon: HelpCircle },
  { uid: "testimonials", label: "Depoimentos", Icon: Star },
  { uid: "portfolio", label: "Portfólio", Icon: ImageIcon },
];

export const BACKOFFICE_TABS = [
  { uid: "leads", label: "Leads", Icon: LayoutDashboard },
  { uid: "site", label: "Site", Icon: Globe },
  { uid: "dev", label: "Dev", Icon: SettingsIcon },
];

export const DEVELOPER_TABS = [
  { uid: "logs", label: "Logs", Icon: FileText },
  { uid: "users", label: "Usuários", Icon: Shield },
  { uid: "email", label: "Email", Icon: Mail },
  { uid: "settings", label: "Configurações", Icon: SettingsIcon },
];

export const MENU_CONTROL_TABS = [
  { uid: "leads", label: "Leads", Icon: LayoutDashboard },
  {
    uid: "site", label: "Site", Icon: Globe,
    children: [
      { uid: "site_hero", label: "Hero", Icon: ImageIcon },
      { uid: "site_about", label: "Sobre", Icon: Info },
      { uid: "site_services", label: "Serviços", Icon: Briefcase },
      { uid: "site_identity", label: "Identidade", Icon: SettingsIcon },
      { uid: "site_sections", label: "Secções", Icon: EyeIcon },
      { uid: "site_sharing", label: "Partilhar", Icon: Share2 },
    ],
  },
  {
    uid: "faq", label: "FAQ", Icon: HelpCircle,
    children: [
      { uid: "faq_faqs", label: "FAQs", Icon: HelpCircle },
      { uid: "faq_questions", label: "Perguntas", Icon: MessageSquare },
    ],
  },
  { uid: "testimonials", label: "Depoimentos", Icon: Star },
  { uid: "portfolio", label: "Portfólio", Icon: Briefcase },
  {
    uid: "dev", label: "Dev", Icon: SettingsIcon,
    children: [
      { uid: "dev_users", label: "Perfis", Icon: Users },
      { uid: "dev_menu", label: "Permissões", Icon: Menu },
      { uid: "dev_roles", label: "Roles", Icon: SettingsIcon },
      { uid: "dev_email", label: "Email", Icon: Mail },
      { uid: "dev_logs", label: "Logs", Icon: FileText },
      {
        uid: "dev_ui", label: "Configuração UI", Icon: Type,
        children: [
          { uid: "ui_headers", label: "Títulos", Icon: Type },
          { uid: "ui_lists", label: "Listas", Icon: List },
          { uid: "ui_interface", label: "Interface", Icon: MousePointer2 },
          {
            uid: "ui_form", label: "Formulário", Icon: FormInput,
            children: [
              { uid: "ui_form_labels", label: "Labels", Icon: Type },
              { uid: "ui_form_services", label: "Serviços", Icon: Briefcase },
              { uid: "ui_form_contacts", label: "Contactos", Icon: Phone },
              { uid: "ui_form_prefixes", label: "Prefixos", Icon: Phone },
              { uid: "ui_form_nationalities", label: "Nacionalidades", Icon: Globe },
            ],
          },
        ],
      },
      { uid: "dev_settings", label: "Configurações", Icon: SettingsIcon },
    ],
  },
];

export const UI_CONFIG_TABS = [
  { value: "headers", icon: Type, label: "Títulos" },
  { value: "lists", icon: List, label: "Menu" },
  { value: "texts", icon: Type, label: "Textos" },
  { value: "interface", icon: MousePointer2, label: "Interface" },
  { value: "form", icon: FormInput, label: "Formulário" },
];

export const UI_FORM_CHILDREN = [
  { value: "labels", label: "Labels" },
  { value: "services", label: "Serviços" },
  { value: "contacts", label: "Contactos" },
  { value: "prefixes", label: "Prefixos" },
  { value: "nationalities", label: "Nacionalidades" },
  { value: "header", label: "Cabeçalho" },
];

export const FORM_TABS = [
  { value: "labels", icon: Tag, label: "Labels" },
  { value: "services", icon: Briefcase, label: "Serviços" },
  { value: "contacts", icon: Mail, label: "Contactos" },
  { value: "prefixes", icon: Phone, label: "Prefixos" },
  { value: "nationalities", icon: Globe, label: "Nacionalidades" },
  { value: "texts", icon: Type, label: "Textos" },
];

export const USER_PANEL_SUB_TABS = [
  { value: "users", icon: Users, label: "Utilizadores" },
  { value: "menu", icon: Menu, label: "Permissões" },
  { value: "roles", icon: SettingsIcon, label: "Funções" },
  { value: "email", icon: Mail, label: "Email" },
  { value: "logs", icon: FileText, label: "Logs" },
  { value: "settings", icon: SettingsIcon, label: "Configurações" },
];

export const SITE_CONTENT_TABS = [
  { value: "menu", icon: List, label: "Menu", children: [
    { value: "lists", icon: List, label: "Links" }, { value: "texts", icon: Type, label: "Textos" },
  ]},
  { value: "hero", icon: ImageIcon, label: "Hero", children: [
    { value: "content", icon: ImageIcon, label: "Conteúdo" }, { value: "texts", icon: Type, label: "Textos" },
  ]},
  { value: "services", icon: Briefcase, label: "Serviços", children: [
    { value: "service", icon: Briefcase, label: "Serviços" }, { value: "texts", icon: Type, label: "Textos" },
  ]},
  { value: "about", icon: Info, label: "Sobre" },
  { value: "portfolio", icon: ImageIcon, label: "Portfólio", children: [
    { value: "items", icon: ImageIcon, label: "Projetos" }, { value: "texts", icon: Type, label: "Textos" },
  ]},
  { value: "testimonials", icon: Star, label: "Depoimentos", children: [
    { value: "testimonial_items", icon: Star, label: "Depoimentos" }, { value: "texts", icon: Type, label: "Textos" },
  ]},
  { value: "faq", icon: HelpCircle, label: "FAQ", children: [
    { value: "faqs", icon: HelpCircle, label: "FAQs" }, { value: "questions", icon: MessageSquare, label: "Recebidas" },
    { value: "categories", icon: FolderTree, label: "Categorias" }, { value: "texts", icon: Type, label: "Textos" },
  ]},
  { value: "blog", icon: BookOpen, label: "Blog", children: [
    { value: "items", icon: BookOpen, label: "Artigos" }, { value: "texts", icon: Type, label: "Textos" },
  ]},
  { value: "form", icon: FormInput, label: "Contacto", children: [
    { value: "labels", icon: Tag, label: "Labels" }, { value: "services", icon: Briefcase, label: "Serviços" },
    { value: "contacts", icon: Mail, label: "Contactos" }, { value: "prefixes", icon: Phone, label: "Prefixos" },
    { value: "nationalities", icon: Globe, label: "Nacionalidades" }, { value: "texts", icon: Type, label: "Textos" },
  ]},
  { value: "footer", icon: MousePointer2, label: "Rodapé" },
  { value: "settings", icon: Layout, label: "Definições", children: [
    { value: "globals", icon: SettingsIcon, label: "Globais" }, { value: "sections", icon: EyeIcon, label: "Seções" },
    { value: "sharing", icon: Share2, label: "Partilhar" }, { value: "locales", icon: Languages, label: "Idiomas" },
  ]},
];

export const LOCALE_FILTERS = [
  { value: "all", label: "Todos" },
  { value: "published", label: "Publicados" },
  { value: "unpublished", label: "Não publicados" },
  { value: "active", label: "Activos" },
  { value: "inactive", label: "Inactivos" },
];

export const TRANSLATE_TABLES = [
  "about", "testimonials", "portfolio", "faqs",
  "form_services", "contact_methods", "form_nationalities", "ui_strings",
];

export const TABLE_LABELS = {
  hero: "Hero", about: "Sobre", services: "Serviços",
  testimonials: "Depoimentos", portfolio: "Portfólio", faqs: "FAQ",
  navigation: "Menu", form_services: "Serviços (Form)",
  contact_methods: "Contactos (Form)", form_nationalities: "Nacionalidades (Form)",
  ui_strings: "Textos UI",
};

export const LOG_LEVELS_MAP = { debug: 0, info: 1, warn: 2, error: 3 };
export const LOG_CONFIG_DEFAULT = { enabled: true, levels: { error: true, warn: true, info: false, debug: false } };

export const LOG_LEVELS_UI = [
  { key: "error", label: "Erro", color: "text-red-600", bg: "bg-red-50", border: "border-red-200" },
  { key: "warn", label: "Aviso", color: "text-amber-600", bg: "bg-amber-50", border: "border-amber-200" },
  { key: "info", label: "Info", color: "text-blue-600", bg: "bg-blue-50", border: "border-blue-200" },
  { key: "debug", label: "Debug", color: "text-gray-600", bg: "bg-gray-50", border: "border-gray-200" },
];

export const SECTION_DEFINITIONS = [
  { key: "hero", label: "Hero", desc: "Banner principal com chamada para ação",
    elements: [{ key: "hero_cta", label: "Botões CTA" }, { key: "hero_scroll", label: "Indicador de scroll" }] },
  { key: "services", label: "Serviços", desc: "Frentes de atuação",
    elements: [{ key: "services_carousel", label: "Carousel / Tarjetas" }, { key: "services_details", label: "Detalhes por serviço" }] },
  { key: "about", label: "Sobre", desc: "Seção sobre a empresa",
    elements: [{ key: "about_image", label: "Imagem" }, { key: "about_stats", label: "Estatísticas" }] },
  { key: "portfolio", label: "Portfólio", desc: "Galeria de projetos", elements: [] },
  { key: "testimonials", label: "Depoimentos", desc: "Depoimentos de clientes", elements: [] },
  { key: "faq", label: "FAQ", desc: "Perguntas frequentes",
    elements: [{ key: "faq_items", label: "Lista de perguntas" }, { key: "faq_form", label: "Formulário de perguntas" }] },
  { key: "blog", label: "Blog", desc: "Artigos e conteúdo editorial",
    elements: [
      { key: "blog_toc", label: "Índice de conteúdo" },
      { key: "blog_comments", label: "Comentários" },
    ] },
  { key: "contact", label: "Contacto", desc: "Formulário e informações de contato",
    elements: [{ key: "contact_info", label: "Bloco de informações" }, { key: "contact_form", label: "Formulário de contacto" }] },
];

export const EMAIL_STATUS = {
  sent: { label: "Enviado", Icon: Mail, color: "text-green-600", bg: "bg-green-50" },
  failed: { label: "Falha", Icon: Mail, color: "text-red-600", bg: "bg-red-50" },
  queued: { label: "Fila", Icon: Mail, color: "text-amber-600", bg: "bg-amber-50" },
  blocked: { label: "Bloqueado", Icon: Mail, color: "text-gray-600", bg: "bg-gray-50" },
};

export const EMAIL_FILTER_OPTIONS = [
  { key: "all", label: "Todos" },
  { key: "sent", label: "Enviados" },
  { key: "queued", label: "Fila" },
  { key: "failed", label: "Falhas" },
  { key: "blocked", label: "Bloqueados" },
];

export const PROCESS_VARIABLES = {
  new_lead: ["{name}", "{email}", "{phone}", "{service}", "{message}", "{contactMethod}", "{date}"],
  new_faq_question: ["{name}", "{email}", "{question}", "{date}"],
  faq_answer: ["{name}", "{email}", "{question}", "{answer}", "{date}"]
};

export const EMAIL_LOG_PAGE_SIZE = 15;
